// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {getPipDetails} from '../../shared/repositories';

const createPipProgram = pipDetails =>
    ({
        description: pipDetails.description,
        internalRecall: pipDetails.internalRecall,
        pipNumber: pipDetails.pipNumber
    });

export const readPipDetails = (pipId, updatePipProgram) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getPipDetails(pipId);

            dispatch({
                data,
                type: actions.UPDATE_CLAIM_PIP_PIP_DETAILS
            });

            dispatch({
                partNumber: data.pipNumber,
                type: actions.UPDATE_CLAIM_PIP_FAILURE_PART
            });

            if (updatePipProgram) {

                const pipProgram = createPipProgram(data);

                dispatch({
                    pipProgram,
                    type: actions.UPDATE_CLAIM_PIP_PIP_PROGRAM
                });

            }

        } catch (error) {

            dispatch({
                type: actions.RESET_CLAIM_PIP_PIP_DETAILS
            });

            dispatch({
                partNumber: '',
                type: actions.UPDATE_CLAIM_PIP_FAILURE_PART
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/pip/action-creators/get-pip-details.js